import './App.css';
import Main from "./main/Main";
import Dashboard from "./views/Dashboard";

const App = () => {

    return (
        <Main>
            <Dashboard/>
        </Main>
    )
}

export default App;
